import { createContext, ReactNode, useEffect, useState } from "react";
import { getEnvVar } from "../../../envUtils";
import { v4 as uuidv4 } from "uuid";
import useUrlParams from "../hooks/useUrlParams";

interface SocketContextType {
    socket: WebSocket | null;
    loading: boolean;
    setLoading: (loading: boolean) => void;
}
export const SocketContext = createContext<SocketContextType | undefined>(undefined);


interface SocketProviderProps {
    children: ReactNode;
}

const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
    const { scenario_id } = useUrlParams();
    const [loading, setLoading] = useState<boolean>(true);
    const [socket, setSocket] = useState<WebSocket | null>(null);

    const create_socket = (sessionId: string): WebSocket | null => {
        try {
            return new WebSocket(`${getEnvVar('REACT_APP_WEBSOCKET_BACKEND_BASE_URL')}test/operate/eventhandler?resourceId=${scenario_id}&sessionId=${sessionId}`);
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    useEffect(() => {
        if (!scenario_id) return;
        const sessionId = uuidv4();
        let ws = create_socket(sessionId);
        const token = sessionStorage.getItem("authentication");
        if (!ws || !token) return;
        ws!.onopen = () => {
            ws!.send(JSON.stringify({ type: 'authorization', token: `${token}` }));
            console.log('Socket Connected');
            setSocket(ws);
        };
        ws!.onclose = () => {
            console.log('Socket Disconnected');
        };

        ws!.onerror = (error) => {
            console.error('Socket Error:', error);
        };
        return () => {
            ws!.close();
        };
    }, [scenario_id])

    return (
        <SocketContext.Provider value={{ socket, loading, setLoading }}>{children}</SocketContext.Provider>
    )
}
export default SocketProvider